import React, { FC, useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import { InputNumber } from "primereact/inputnumber";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import Word from "saur_ui_library/src/Atoms/Word/Word";

type Props = {
  seuilTitle: any;
  getSeuilMin?: any;
  getSeuilMax?: any;
  sendSeuilMax: any;
  sendSeuilMin: any;
};

const Seuil: FC<Props> = ({
  seuilTitle,
  getSeuilMin,
  getSeuilMax,
  sendSeuilMin,
  sendSeuilMax
}) => {
  //variables de saison
  const [seuilMin, setSeuilMin] = useState<any>(getSeuilMin);
  const [seuilMax, setSeuilMax] = useState<any>(getSeuilMax);

  useEffect(() => {
    sendSeuilMin(seuilMin);
    sendSeuilMax(seuilMax);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seuilMin, seuilMax]);


  return (
    <Container className="seuilBoxContainer sds-reset-style">
      <Styles />

          <Container className="blueline"></Container>
          <Container className="variableBody">
          <Word
              variant="span"
              textStyle="normalBold"
              value={seuilTitle}
              className="variable-min"
            />
            <Word
              variant="span"
              textStyle="normalReg"
              value="Min"
              className="variable-min"
            />
            <InputNumber
              className="seuil-input"
              id="input-seuil-min"
              value={seuilMin}
              onValueChange={(e: any) => {
                if(e.value !== null){
                  setSeuilMin(e.value);
                }
              }}
              min={0}
              max={100}
            />
            <Word
              variant="span"
              textStyle="normalReg"
              value="Max"
              className="variable-max"
            />
            <InputNumber
              className="seuil-input"
              id="input-seuil-max"
              value={seuilMax}
              onValueChange={(e: any) => {
                if(e.value !== null){
                  setSeuilMax(e.value);
                }
              }}
              min={0}
              max={100}
            />
          </Container>

    </Container>
  );
};
const Styles = createGlobalStyle`
.seuilBoxContainer.sds-reset-style{

}
 
`;
export default Seuil;
